export default function PolicyViewModal({ title, contentHtml, onClose }) {
  return (
    <div className="modal-overlay open pdpa-policy-overlay" onClick={(event) => event.target === event.currentTarget && onClose()}>
      <div className="modal pdpa-policy-modal" style={{ width: '720px' }}>
        <div className="modal-header">
          <div className="modal-title">{title}</div>
          <button className="modal-close" onClick={onClose} aria-label="ปิด">
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>
        <div className="modal-body pdpa-policy-body">
          <iframe
            title={title}
            className="pdpa-policy-frame"
            sandbox="allow-same-origin"
            srcDoc={contentHtml}
          />
        </div>
        <div className="modal-footer pdpa-policy-footer">
          <button type="button" className="btn btn-primary pdpa-save-btn" onClick={onClose}>
            รับทราบ
          </button>
        </div>
      </div>
    </div>
  );
}
